import { useMemo, useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CustomDivider from '../../shared/utils/CustomDivider';
import { Box, Button, Grid2 } from '@mui/material';
import useAuthStore from '../../store/useAuthStore';
import { useFacilityList } from '../../assets/api/useAdminApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import UtItem from '../../shared/utils/UtList';
import { Constants, Grid_Gap } from '../../shared/constants';
// import api from '../../assets/api/useStudentPostApi';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { useApartmentFacility } from '../../assets/api/useMarketingExecutive';
import AssignFacilityTable from './AssignFacilityTable';
import { useDialog } from '../../shared/hook/useDialog';
import AdminToolbar from '../admin/components/AdminToolbar';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import api from '../../assets/nodeApi/axiosInstance';

const AssignFacility = () => {
    const { user, token } = useAuthStore();
    const [filters, setFilters] = useState({});
    const { open, handleClickOpen, handleClose } = useDialog();
    const { data: facilityApartmentList, isLoading: isFacilityApartmntLoading } = useApartmentFacility()
    const [searchQuery, setSearchQuery] = useState('');
    const matchedFacility = facilityApartmentList?.find(
        item => item?.apartment_id == user?.apartment_id
    )

    const facilityRow = matchedFacility?.facilities?.map((item, index) => ({
        id: index + 1,
        sr_no: index + 1,
        ...item
    })) || []
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();
    const [selectedFacility, setSelectedFacility] = useState([])
    const { data: facilityList, isLoading } = useFacilityList()
    const facilityOption = facilityList?.map((item) => ({
        id: item?.id,
        value: item?.name,
        label: item?.name
    })) || [];
    const validationSchema = Yup.object().shape({
    });
    const initialValues = {
        facility_id: ""
    };
    const handleRemove = (id) => {
        setSelectedFacility(prev => prev.filter(apartment => apartment?.id !== id));
    };
    const mutation = useMutation({
        mutationFn: (formData) => api.post("apartment-facilities", formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ),
    });
    const facilities = facilityOption.map(option => {
        const isSelected = selectedFacility.some(facility => facility?.id === option?.id);
        return {
            facility_id: option?.id,
            is_available: isSelected ? "yes" : "no",
            status: isSelected ? "active" : "inactive"
        };
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        if (selectedFacility.length === 0) {
            showToaster('At least one facility must be selected', 'Warning', 'warning');
            setSubmitting(false);
            return;
        }

        const data = {
            apartment_id: user?.apartment_id,
            facilities
        };
        mutation.mutate(data, {
            onSuccess: (response) => {
                showToaster('Success', response?.data?.message, 'success')
                queryClient.invalidateQueries({ queryKey: ['apartment-facilities'] });
                resetForm();
                setSelectedFacility([])
            },
            onError: (error) => {
                showToaster(error?.response?.data?.message || "Something Went wrong While submiting Form", 'Error', 'error')
            },
            onSettled: () => {
                setSubmitting(false);
            },
        });

    }



    const handleSearchChange = (value) => {
        setSearchQuery(value);
    };
    const originalRow = useMemo(() => {
        return matchedFacility?.facilities?.map((item, index) => ({
            id: index + 1,
            sr_no: index + 1,
            ...item
        })) || [];
    }, [facilityList]);
    const filteredRows = useMemo(() => {
        return originalRow.filter(item => {
            const matchesSearch = !searchQuery.trim() || Object.values(item).some(val =>
                val != null && val.toString().toLowerCase().includes(searchQuery.toLowerCase())
            );
            const matchesFilters = Object.entries(filters).every(([key, value]) => {
                if (!value) return true; // skip empty filters
                return item[key]?.toString().toLowerCase() === value.toLowerCase();
            });

            return matchesSearch && matchesFilters;
        });
    }, [originalRow, searchQuery, filters]);

    const initialValuesFilter = {

    };

    const validationSchemaFilter = Yup.object().shape({

    });
    const handleSubmitFilter = (values, { resetForm }) => {
        const filteredValues = Object.fromEntries(
            Object.entries(values).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        );
        setFilters(filteredValues);
        handleClose();
        // resetForm()
    };

    const uniqueStatusOptions = [
        ...new Set(
            matchedFacility?.facilities?.map(item => item?.status).filter(Boolean)
        ),
    ].map((status, index) => ({
        id: index + 1,
        label: status,
        value: status,
    }));
    return (
        <>
            <NormalContainerWithHeader headerText={"Assign Facility"}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {() => (
                        <Form>
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 1,
                                    mb: 5
                                }}
                            >
                                {selectedFacility?.map((item, index) => (
                                    <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />
                                ))}
                            </Box>

                            <Grid2 container spacing={Grid_Gap}>

                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="facility_id"
                                        component={IdAutoCompleteField}
                                        options={facilityOption}
                                        label="Facility Option"
                                        isRequired={true}
                                        isLoading={isLoading}
                                        onValueChange={(newValue) => {
                                            if (!newValue) return;

                                            const values = Array.isArray(newValue) ? newValue : [newValue];

                                            setSelectedFacility((prev) => {
                                                const filtered = values.filter((val) => val?.id); // ✅ remove empty
                                                const merged = [...prev];

                                                filtered.forEach((val) => {
                                                    if (!merged.some((item) => item.id === val.id)) {
                                                        merged.push(val);
                                                    }
                                                });

                                                return merged;
                                            });
                                        }}
                                    />
                                </Grid2>

                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={{ xs: 6, md: 4 }}>
                                    <Button variant='contained' type='submit' fullWidth>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </NormalContainerWithHeader>
            <CustomDivider />
            <NormalContainerWithHeader headerText={"Facility Table"}
                RightContent={
                    <AdminToolbar
                        onSearchChange={handleSearchChange}
                        onFilterClick={handleClickOpen}
                        filterIcon={Constants.customImages.FilterDark}

                    />
                }
            >
                <AssignFacilityTable facilityRow={filteredRows} isLoading={isFacilityApartmntLoading} />
            </NormalContainerWithHeader>
            <MainDialogBox open={open} handleClose={handleClose} width={"40%"}>
                <Formik initialValues={filters} enableReinitialize={true} validationSchema={validationSchemaFilter} onSubmit={handleSubmitFilter}>
                    {() => (
                        <Form>
                            <Grid2 container spacing={"20px"}>
                                <Grid2 children size={12}>
                                    <Field
                                        name="status"
                                        component={AutoCompleteField}
                                        options={uniqueStatusOptions}
                                        label="Select Status"
                                        isRequired={true}
                                        isLoading={isFacilityApartmntLoading}
                                    />
                                </Grid2>
                                <Grid2 children textAlign={"end"} size={12}>
                                    <Button variant='contained' type='submit' fullWidth>Submit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </>
    )
}

export default AssignFacility